// For special cases when we're on actual TLD (hint: localhost)
const isTld = (hostname) => !hostname.includes('.');
const HOSTNAME = window.location.hostname;
const DOMAIN_NAME = (isTld(HOSTNAME) ? '' : '.') + HOSTNAME.split('.').slice(-2).join('.');
// SID cookie properties
export const SID_COOKIES_PROP = {
    name: 'sid',
    options: {
        'domain': DOMAIN_NAME,
        'secure': window.location.protocol === 'https:',
        'max-age': 30 * 24 * 60 * 60, // 30 days
    },
};
